import { handleSelectLocation } from '../../modules/events/consultListeners';
import { locationId, staffId } from '../../utils/variables';
import { t } from '../../utils/i18n';

export function loadLocationsDropdown(locations) {
    let tempLocations = locations;
    if(staffId && locationId) {
        tempLocations = locations?.filter(l => l.id === locationId);
    }
    let list = document.querySelector(
        '.locationsDropdown__wrapper .locationsDropdown__select'
    );
    if (list) {
        list.innerHTML = '';
    
        if (tempLocations.length <= 0) {
            list.insertAdjacentHTML(
                'beforeend',
                `
                <li>${t('no_locations_found')}</li>
            `
            );
        }
    
        for (const lo of tempLocations) {
            list.insertAdjacentHTML(
                'beforeend',
                `
            <li class="locations-dropdown__option"
                data-location-id="${lo.id}"
                data-location="${lo.name}"
            >
            ${lo.name}
            </li>
            `
            );
        }
    
        handleSelectLocation();
    }
}
